export enum ECampaign {
  APP = 'APP',
  CHATBOT = 'CHATBOT',
  NULL = '_NULL',
  PACKAGE_PREFIX = 'PK',
  RECHARGE = 'RECARGAS',
  REDIRECT = 'REDIRECT',
  SAT = 'HSMS',
  USA = 'XTRNL'
}
